// Unit Converter Tool — length, weight, temperature, volume, area, speed, data, time.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";
import { CATEGORIES } from "./lib/units";

export const unitConverterTool: Tool = {
  id: "unit-converter",
  name: () => m.uc_tool_name(),
  description: () => m.uc_tool_description(),
  icon: "🔁",
  basePath: "/unit-converter",
  status: "stable",
  tags: ["converter", "units", "measurement", "calculator"],
  pages: [
    {
      name: () => m.uc_nav_main(),
      path: "/unit-converter",
      description: () => m.uc_nav_main_desc(),
      icon: "🔁",
    },
    {
      name: () => CATEGORIES.length.name(),
      path: "/unit-converter/length",
      description: () => m.uc_nav_cat_desc(),
      icon: "📏",
    },
    {
      name: () => CATEGORIES.weight.name(),
      path: "/unit-converter/weight",
      description: () => m.uc_nav_cat_desc(),
      icon: "⚖️",
    },
    {
      name: () => CATEGORIES.temperature.name(),
      path: "/unit-converter/temperature",
      description: () => m.uc_nav_cat_desc(),
      icon: "🌡️",
    },
  ],
};
